import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


export class ZrButtonComponent implements OnInit {
   text?: string = 'button';
   data?: any;
   size?: string = ''; // button size ['btn-lg'，'btn-sm']
   bg?: string = 'btn-secondary';
   disabled?: boolean = false;
   icon?: string = '';
   borderRadius?: string = ''; // button border radius ['m-btn--square'，'m-btn--pill']
   shadow?: boolean = false; // button shadow
   toggle?: boolean = false;

   clickEventer = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  click() {
    this.clickEventer.emit(this.data);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'zr-button',
  template: `
  <button type="button" class="btn {{bg}}" (click)="click()" 
    [disabled]="disabled" [ngClass]="{'dropdown-toggle':toggle,'m-btn--air':shadow,
    'btn-sm':size==='sm','btn-lg':size==='lg','m-btn--square':borderRadius==='square',
    'm-btn--pill':borderRadius==='pill'}">
    <i class="{{icon}}"></i>
    {{text}}
  </button>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'text': [{ type: Input },],
'data': [{ type: Input },],
'size': [{ type: Input },],
'bg': [{ type: Input },],
'disabled': [{ type: Input },],
'icon': [{ type: Input },],
'borderRadius': [{ type: Input },],
'shadow': [{ type: Input },],
'toggle': [{ type: Input },],
'clickEventer': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
